import { render, staticRenderFns } from "./ManualBookingClientInformation.vue?vue&type=template&id=31b0dee5&"
import script from "./ManualBookingClientInformation.vue?vue&type=script&lang=ts&"
export * from "./ManualBookingClientInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports